import { IResourceResponse } from "@colibrio/colibrio-reader-framework/colibrio-core-io-base";
import { IEpubContentDocument, IEpubOcfResourceProvider } from "@colibrio/colibrio-reader-framework/colibrio-core-publication-epub";

export interface ExtractedXHTML {
    indexInSpine: number,
    text: string,
}

export async function extractXHTML(spine: IEpubContentDocument[], ocfResourceProvider: IEpubOcfResourceProvider): Promise<ExtractedXHTML[]> {
    return Promise.all(spine.map(async (doc) => ({
        indexInSpine: doc.getIndexInSpine(), 
        text: await getXHTMLFromFile(doc.getContentUrl(), ocfResourceProvider)
    } as ExtractedXHTML)))
}

async function getXHTMLFromFile(url: URL, ocfResourceProvider: IEpubOcfResourceProvider): Promise<string> {
    return new Promise(async (res, rej) => {
        try {
            const response: IResourceResponse = await ocfResourceProvider.fetch(url);
            const stream = response.getReadableStream();
            const reader = stream.getReader();
            const chunks: Uint8Array[] = [];
    
            let done = false;
            while (!done) {
                const { value, done: chunkDone } = await reader.read();
                if (value) chunks.push(value);
                done = chunkDone;
            }
    
            // Create a Blob from the collected chunks
            const blob = new Blob(chunks, { type: "text/plain" });
    
            const fileReader = new FileReader();
            fileReader.onload = () => {
                const fileContent = fileReader.result as string;
                res(fileContent);
            }
            fileReader.readAsText(blob);
        } catch (err) {
            console.error('Error retrieving XHTML: ', err);
            rej(err);
        }
    });
}